
class ContactButton extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback(){
        this.button = this.querySelector('button');

        this.sections = document.querySelectorAll('section')
        this.scrollDestinationSection = this.sections[this.sections.length - 2]

        this.button.addEventListener('click', () => {
            const coords = this.scrollDestinationSection.getBoundingClientRect();
            const { y } = coords;
            window.scrollTo({
                top: y,
                behavior: "smooth"
            })
        })
    }
   
  }
  
  customElements.define('contact-button', ContactButton);
  